import { render, staticRenderFns } from "./StockAssemblyMovements.vue?vue&type=template&id=55ccfd01&scoped=true&"
import script from "./StockAssemblyMovements.vue?vue&type=script&lang=ts&"
export * from "./StockAssemblyMovements.vue?vue&type=script&lang=ts&"
import style0 from "./StockAssemblyMovements.vue?vue&type=style&index=0&id=55ccfd01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ccfd01",
  null
  
)

export default component.exports